import { render } from "./InquiryInput.vue?vue&type=template&id=05edf0e2"
import script from "./InquiryInput.vue?vue&type=script&lang=js"
export * from "./InquiryInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__